import messages from '../assets/i18n'

function selectLanguage (languageToSelect) {
  const language = languageToSelect;
  return Object.keys(messages).find( lang => lang.toLowerCase() === language.toLowerCase() );
}

export default selectLanguage;